// eslint-disable-next-line no-restricted-imports
import { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
import {
  LoadHeaderDocument,
  LoadHeaderQuery,
  LoadHeaderQueryVariables,
} from './LoadHeaderQuery.generated';

// Action types
export const LOAD_HEADER_REQUEST = Symbol('loaders/LOAD_HEADER_REQUEST');
export const LOAD_HEADER_SUCCESS = Symbol('loaders/LOAD_HEADER_SUCCESS');
export const LOAD_HEADER_ERROR = Symbol('loaders/LOAD_HEADER_ERROR');

export type LoadHeaderRequestAction = Action<
  typeof LOAD_HEADER_REQUEST,
  string
>;
export type LoadHeaderSuccessAction = Action<
  typeof LOAD_HEADER_SUCCESS,
  MemberResponse
>;
export type LoadHeaderErrorAction = Action<typeof LOAD_HEADER_ERROR, Error>;

// Action creators
const loadHeaderRequest = actionCreator<LoadHeaderRequestAction>(
  LOAD_HEADER_REQUEST,
);
const loadHeaderSuccess = actionCreator<LoadHeaderSuccessAction>(
  LOAD_HEADER_SUCCESS,
);
const loadHeaderError = actionCreator<LoadHeaderErrorAction>(LOAD_HEADER_ERROR);

export const loadHeader = (idMember: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(loadHeaderRequest(idMember));

    const { data, error } = await client.query<
      LoadHeaderQuery,
      LoadHeaderQueryVariables
    >({
      query: LoadHeaderDocument,
      variables: {
        id: idMember,
      },
      context: {
        operationName: 'LoadHeader',
        document: LoadHeaderDocument,
      },
      // eslint-disable-next-line @trello/disallow-fetch-policies
      fetchPolicy: 'network-only',
    });
    if (error) {
      dispatch(loadHeaderError(error));
    } else {
      const member = data.member;

      if (!member) {
        return;
      }

      dispatch(loadHeaderSuccess(member));
    }
  };
};
